<ng-container *transloco="let translate;">
    <div class="flex items-center justify-between w-full mx-auto px-4 py-2 pb-4">
        <h1 class="text-xl font-semibold" [textContent]="translate('Associate')"></h1>
        <button [title]="'Close'" (click)="closeModal()" class="p-2 rounded-full hover:bg-gray-100 focus:outline-none">
            <mat-icon class="font-bold text-lg">close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="w-full h-[76%] overflow-auto px-4 py-2 relative !left-[15px]">
        <app-lib-consolidate [apps]="allSubscribedApps" [selectedRecordIds]="selectedInstanceIds" [sourceApp]="service" [currentOrganizationId]="currentOrganizationId" (closeConsolidate)="closeModal()"></app-lib-consolidate>
    </mat-dialog-content>
</ng-container>
